import { render, staticRenderFns } from "./ResearchSingleSearchV2.vue?vue&type=template&id=1c9e8b0f"
import script from "./ResearchSingleSearchV2.vue?vue&type=script&lang=js"
export * from "./ResearchSingleSearchV2.vue?vue&type=script&lang=js"
import style0 from "./ResearchSingleSearchV2.vue?vue&type=style&index=0&id=1c9e8b0f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c9e8b0f')) {
      api.createRecord('1c9e8b0f', component.options)
    } else {
      api.reload('1c9e8b0f', component.options)
    }
    module.hot.accept("./ResearchSingleSearchV2.vue?vue&type=template&id=1c9e8b0f", function () {
      api.rerender('1c9e8b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSingleSearchV2.vue"
export default component.exports